var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "low-risk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_80193",
    "data-name": "Path 80193",
    d: "M11,6A2,2,0,0,0,9,8v8a2,2,0,0,0,4,0V8A2,2,0,0,0,11,6Zm.667,10a.667.667,0,0,1-1.333,0V8a.667.667,0,0,1,1.333,0Z",
    transform: "translate(-3 -2)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80194",
    "data-name": "Path 80194",
    d: "M20,0a2,2,0,0,0-2,2V14a2,2,0,0,0,4,0V2A2,2,0,0,0,20,0Zm.667,14a.667.667,0,1,1-1.333,0V2a.667.667,0,1,1,1.333,0Z",
    transform: "translate(-6)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_80195",
    "data-name": "Path 80195",
    d: "M2,12a2,2,0,0,0-2,2v4a2,2,0,1,0,4,0V14a2,2,0,0,0-2-2Z",
    transform: "translate(0 -4)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/low-risk.c6cfa9eca6f9d0410195432629151e15.svg";
export { ForwardRef as ReactComponent };